<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeDangerZone')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"> <h1>Danger Zone</h1> </slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('closeDangerZone')"/>
            <h4>Danger Zone</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <b-row>
                <b-col cols="12" sm="12" class="col-image">
                  <div v-if="status === localConstants.STATUS_UPDATING">
                    <b-spinner/>
                  </div>
                  <div v-else-if="status === localConstants.STATUS_ERROR_UPDATING">
                    <div class="alert alert-danger">
                      Temporary Error during loading. Please try to refresh the page and see if the error persists.
                      <b-button variant="secondary" @click="status = ''">
                        Ok
                      </b-button>
                    </div>
                  </div>
                  <div v-else>
                    <b-button variant="warning" size="lg" @click="deactivateAllOffers()">
                      Deactivate all Offers
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer text-right">
              <b-button variant="primary" @click="$emit('closeDangerZone')">
                Cancel
              </b-button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';

export default {
  name: 'AdminSellingOfferDangerZone',
  data: function() {
    return {
      status: '',
      localConstants: {
        STATUS_UPDATING: 'updating',
        STATUS_ERROR_UPDATING: 'errorUpdating',
        STATUS_FINISHED_UPDATING: 'finishedUpdating',
      },
    };
  },
  methods: {
    deactivateAllOffers() {
      let options = {
        method: 'post',
        baseURL: constants.url.offerService.baseUrl,
        url: constants.url.offerService.api.deactivateAllOffers,
      };
      this.status = this.localConstants.STATUS_UPDATING;
      apiAuth(options)
        .then(() => {
          this.status = this.localConstants.STATUS_FINISHED_UPDATING;
          this.$emit('closeDangerZoneAndRefresh');
        })
        .catch(() => {
          this.status = this.localConstants.STATUS_ERROR_UPDATING;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
